/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Quota_TitleInputs */

const en_why_listening_quota_title = /** @type {(inputs: Why_Listening_Quota_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No word budget. No hour cap.`)
};

const es_why_listening_quota_title = /** @type {(inputs: Why_Listening_Quota_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin límite de palabras. Sin límite de horas.`)
};

/**
* | output |
* | --- |
* | "No word budget. No hour cap." |
*
* @param {Why_Listening_Quota_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_quota_title = /** @type {((inputs?: Why_Listening_Quota_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Quota_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_quota_title(inputs)
	return en_why_listening_quota_title(inputs)
});